import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import Loader from './Loader';
import AppHeader2 from './AppHeader2';
import BottomMenu from './BottomMenu';
import SidebarPanel from './SidebarPanel';
  
class CancellationRefunds extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            LOCATION: this.props.location.pathname,
            LOADING: true, 
            userNAME: '',
            userIMAGE: '',
            userMOBILE: '',
            userVERIFIED: '',
            userEMAIL: '',
            activeORDERS: '',
            LoggedOut: false,
            CUSTOMER_DET: ''
        };
    }

    fetchCustomerProfile(mode,customer) {
        var that = this;
        fetch('https://m.donedelivery.in/api/profile_api2.php?mode='+mode+'&customer='+customer,{
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Access-Control-Allow-Origin': '*', 
                Accept: 'application/json', 
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (result) {

            var CUSTOMER_DET = 'Hi User';
            if(result.CUSTOMER!=='' && result.CUSTOMER!==undefined && result.CUSTOMER!=='undefined')
                CUSTOMER_DET = result.CUSTOMER;
                            
            that.setState({ LOADING:false, CUSTOMER_DET:CUSTOMER_DET  });
        });
    }

    handleClickModalLogOut = () => {
        $('#ModalLogout').modal('show');
    }

    handleClickLogOut = () => {
        localStorage.removeItem('userData');
        this.setState({ LoggedOut:true });
    }

    componentWillMount() {
        let mount = $("div").hasClass("modal-backdrop");
        if(mount==true)
        {
            $('body').removeClass('modal-open');
            $(".modal-backdrop").remove();
            //window.location.reload(true);
        }
    }
    
    componentDidMount() {
        var customer = localStorage.getItem('userData');
        this.fetchCustomerProfile('PROFILE',customer);
    }
    
    render() { 

        //console.log(localStorage.getItem('delCity'));
        //console.log(localStorage.getItem('delArea'));
        
        let AppHeaderClass = 'appHeader bg-dark text-light';
        let AppHeaderLeft = 'showLINK';
        let AppHeaderLeftLink = '/home';
        let AppHeaderTitle = 'Disclaimer';
        let AppHeaderRight = '';
        let AppHeaderRightLink = 'SEARCH';
        let AppHeaderSearch = '';
        
        return (
            <div>
                {this.state.LOADING && <Loader />}
                <AppHeader2 AppHeaderClass={AppHeaderClass} AppHeaderLeft={AppHeaderLeft} AppHeaderLeftLink={AppHeaderLeftLink} AppHeaderTitle={AppHeaderTitle} AppHeaderRight={AppHeaderRight} AppHeaderRightLink={AppHeaderRightLink} AppHeaderSearch={AppHeaderSearch}/>
                <div id="appCapsule">
                    <div className="section full mt-2">
                        <div className="pr-2 pl-2 pt-2 pb-1 font-size-14">
                            <ul className="set1 pl-2">
                                <li className="mb-1">THE PLATFORM MAY BE UNDER CONSTANT UPGRADES, AND SOME
                                FUNCTIONS AND FEATURES MAY NOT BE FULLY OPERATIONAL.</li>
                                <li className="mb-1">DUE TO THE VAGARIES THAT CAN OCCUR IN THE ELECTRONIC
                                DISTRIBUTION OF INFORMATION AND DUE TO THE LIMITATIONS INHERENT
                                IN PROVIDING INFORMATION OBTAINED FROM MULTIPLE SOURCES, THERE
                                MAY BE DELAYS, OMISSIONS, OR INACCURACIES IN THE CONTENT
                                PROVIDED ON THE PLATFORM OR DELAY OR ERRORS IN FUNCTIONALITY
                                OF THE PLATFORM. AS A RESULT, WE DO NOT REPRESENT THAT THE
                                INFORMATION POSTED IS CORRECT IN EVERY CASE.</li>
                                <li className="mb-1">WE EXPRESSLY DISCLAIM ALL LIABILITIES THAT MAY ARISE AS A
                                CONSEQUENCE OF ANY UNAUTHORIZED USE OF CREDIT/ DEBIT CARDS.</li>
                                <li className="mb-1">YOU ACKNOWLEDGE THAT THIRD PARTY SERVICES ARE AVAILABLE ON
                                THE PLATFORM. WE MAY HAVE FORMED PARTNERSHIPS OR ALLIANCES
                                WITH SOME OF THESE THIRD PARTIES FROM TIME TO TIME IN ORDER TO
                                FACILITATE THE PROVISION OF CERTAIN SERVICES TO YOU. HOWEVER,
                                YOU ACKNOWLEDGE AND AGREE THAT AT NO TIME ARE WE MAKING ANY
                                REPRESENTATION OR WARRANTY REGARDING ANY THIRD PARTY'S
                                SERVICES NOR WILL WE BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY
                                CONSEQUENCES OR CLAIMS ARISING FROM OR IN CONNECTION WITH SUCH
                                THIRD PARTY INCLUDING, AND NOT LIMITED TO, ANY LIABILITY OR
                                RESPONSIBILITY FOR, DEATH, INJURY OR IMPAIRMENT EXPERIENCED BY
                                YOU OR ANY THIRD PARTY. YOU HEREBY DISCLAIM AND WAIVE ANY
                                RIGHTS AND CLAIMS YOU MAY HAVE AGAINST US WITH RESPECT TO
                                THIRD PARTY'S / PARTNER shopS SERVICES.</li>
                                <li className="mb-1">DONE DELIVERY / PALASHA ENTERPRISES DISCLAIMS AND ALL LIABILITY
                                THAT MAY ARISE DUE TO ANY VIOLATION OF THE FOOD SAFETY AND
                                STANDARDS ACT, 2006 AND APPLICABLE RULES AND REGULATIONS MADE
                                THEREUNDER AND SUCH LIABILITY SHALL BE ATTRIBUTABLE TO THE
                                PARTNER shop.</li>
                                <li className="mb-1">WHILE THE MATERIALS PROVIDED ON THE PLATFORM WERE PREPARED TO
                                PROVIDE ACCURATE INFORMATION REGARDING THE SUBJECT DISCUSSED,
                                THE INFORMATION CONTAINED IN THESE MATERIALS IS BEING MADE
                                AVAILABLE WITH THE UNDERSTANDING THAT WE MAKE NO GUARANTEES,
                                REPRESENTATIONS OR WARRANTIES WHATSOEVER, WHETHER EXPRESSED
                                OR IMPLIED, WITH RESPECT TO PROFESSIONAL QUALIFICATIONS,
                                EXPERTISE, QUALITY OF WORK OR OTHER INFORMATION HEREIN.
                                FURTHER, WE DO NOT, IN ANY WAY, ENDORSE ANY SERVICE OFFERED OR
                                DESCRIBED HEREIN. IN NO EVENT SHALL WE BE LIABLE TO YOU OR ANY
                                THIRD PARTY FOR ANY DECISION MADE OR ACTION TAKEN IN RELIANCE
                                ON SUCH INFORMATION.</li>
                                <li className="mb-1">THE INFORMATION PROVIDED HEREUNDER IS PROVIDED ?AS IS?. WE AND /
                                OR OUR EMPLOYEES MAKE NO WARRANTY OR REPRESENTATION
                                REGARDING THE TIMELINESS, CONTENT, SEQUENCE, ACCURACY,
                                EFFECTIVENESS OR COMPLETENESS OF ANY INFORMATION OR DATA
                                FURNISHED HEREUNDER OR THAT THE INFORMATION OR DATA PROVIDED
                                HEREUNDER MAY BE RELIED UPON. MULTIPLE RESPONSES MAY USUALLY
                                BE MADE AVAILABLE FROM DIFFERENT SOURCES AND IT IS LEFT TO THE
                                JUDGEMENT OF USERS BASED ON THEIR SPECIFIC CIRCUMSTANCES TO USE,
                                ADAPT, MODIFY OR ALTER SUGGESTIONS OR USE THEM IN CONJUNCTION
                                WITH ANY OTHER SOURCES THEY MAY HAVE, THEREBY ABSOLVING US AS
                                WELL AS OUR CONSULTANTS, BUSINESS ASSOCIATES, AFFILIATES,
                                BUSINESS PARTNERS AND EMPLOYEES FROM ANY KIND OF PROFESSIONAL
                                LIABILITY.</li>
                                <li className="mb-1">WE SHALL NOT BE LIABLE TO YOU OR ANYONE ELSE FOR ANY LOSSES OR
                                INJURY ARISING OUT OF OR RELATING TO THE INFORMATION PROVIDED
                                ON THE PLATFORM. IN NO EVENT WILL WE OR OUR EMPLOYEES,
                                AFFILIATES, AUTHORS OR AGENTS BE LIABLE TO YOU OR ANY THIRD
                                PARTY FOR ANY DECISION MADE OR ACTION TAKEN BY YOUR RELIANCE
                                ON THE CONTENT CONTAINED HEREIN.</li>
                                <li className="mb-1">IN NO EVENT WILL WE BE LIABLE FOR ANY DAMAGES (INCLUDING,
                                WITHOUT LIMITATION, DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
                                CONSEQUENTIAL OR EXEMPLARY DAMAGES, DAMAGES ARISING FROM
                                PERSONAL INJURY/WRONGFUL DEATH, AND DAMAGES RESULTING FROM
                                LOST PROFITS, LOST DATA OR BUSINESS INTERRUPTION), RESULTING FROM
                                ANY SERVICES PROVIDED BY ANY THIRD PARTY OR PARTNER
                                shop ACCESSED THROUGH THE PLATFORM, WHETHER BASED ON
                                WARRANTY, CONTRACT, TORT, OR ANY OTHER LEGAL THEORY AND
                                WHETHER OR NOT WE ARE ADVISED OF THE POSSIBILITY OF SUCH
                                DAMAGES.</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <BottomMenu LOCATION={this.state.LOCATION} />
                {this.state.CUSTOMER_DET && <SidebarPanel CUSTOMER_DET={this.state.CUSTOMER_DET}/>}
            </div>
        );
    }
}
      
export default CancellationRefunds;


// WEBPACK FOOTER //
// ./src/components/Disclaimer.js